import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, FormControl, Validators, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { RouteService } from 'app/services/route.service';
import { CountryService } from 'app/services/country.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PlaceService } from 'app/services/place.service';
import { error } from 'protractor';
import { AuthWebService } from 'app/services/authweb.service';
declare var $: any;

@Component({
  selector: 'app-add-route',
  templateUrl: './add-route.component.html',
  styleUrls: ['./add-route.component.css'],
  providers: [RouteService]
})
export class AddRouteComponent implements OnInit {
  form;
  cType: any = {};
  sub: any;
  lblHeading = 'Standard Route';
  btnActionLabel = '';
  isEdit: boolean = false;
  isDup = false;
  selectedGroupCode: any = {};
  selectedDisplay = 3;
  message = null;
  now = new Date();
  audit = { created: '', updated: '' };
  user = { LastName: '' };
  selectedRoute_type_ind = 1;
  public isLoading = false;
  public countries: any = [];
  public departurePlaces: any = [];
  public selectedDepartureCountry;
  public destinationPlaces: any = [];
  public selectedDestinationCountry;
  borderCrossings: UntypedFormArray;
  borderPlaces: any = [];
  selectedBorderCrossings: any = [];
  ctrlId = 0;
  destinationId = 0;
  isCodeDup = false;
  routeLeg: any;
  isAllowed = false;
  isDefault = 0;
  isAddModel = false;
  isSelected = true;
  trackIndex = 0;
  destId = 0;
  list_borders = [];
  ls_destination = [];
  isRequired = false;
  @Input() routeCtrl: any = { isNew: false };
 

  constructor(private countryService: CountryService, private formBuilder: UntypedFormBuilder,
    public utility: UtilityServiceService, private toastr: ToastrService, private placeService: PlaceService,
    private routeService: RouteService, private routr: Router, private route: ActivatedRoute, private authWebService: AuthWebService) { }

  ngOnInit() {
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.initForm();
    //this.onChanges();
    this.reloadCountries();
    if (!this.routeCtrl.isNew) {
      this.setEditDefault();
      this.isWithLegs();

    } else {
      //console.log('RouteCtrl', this.routeCtrl);
      this.isAllowed = true;
      //this.ctrlTabs();
      this.addValidation();
      $('#bord').removeClass('active');
      $('#desc').addClass('active');
      $('#desc').addClass('show');
      

    }
    
  }

  

  initForm() {
    this.form = this.formBuilder.group({
      id: [0, []],      
      route_type_ind: [1, [<any>Validators.required]],
      display_ind: ['', [<any>Validators.required]],
      code: [this.generateCode(), [<any>Validators.required]],
      route_detail: ['', []],
      route_summary: ['', [<any>Validators.required]],
      description: ['', [<any>Validators.required]],
      is_active: [true, [<any>Validators.required]],
      sort_order: [1, [<any>Validators.required]],
      group_code: ['A', [<any>Validators.required]],      
      date_created: [new Date(), [<any>Validators.required]],     
      departure_country_id: [0, []],
      destination_country_id: [0, []],
      route_led_id: [0, []],
      departure_place_id: ['', []],
      destination_place_id: ['', []],
      borderCrossings: this.formBuilder.array([]),
      first_place_leg_id:[0,[]]
    });
    this.audit = this.utility.setAuditAttributes(this.now, environment.authWebApi.userData.User.FirstName, this.now, environment.authWebApi.userData.User.FirstName);
    this.addValidation();
  }

  

  onSelectChange() {
    //console.log(this.selectedDisplay)
  }
  setEditDefault() {
    this.route.params.subscribe(params => {
      if (this.routr.url.indexOf('edit') != -1) {
        this.isEdit = true;
        const id = +params['id'];
        this.lblHeading = 'Edit Standard Route';
        //this.currentRoute(id);
        this.onLoadRouteById(id);

      }
    });

  }
  
  getRoutes() {
    this.routeService.getAllRoute().subscribe(data => {
      ////console.log(data);
    });
  }
  editRoute(route) {
    this.routeService.editRoutes(route).subscribe((x: any) => {
      //console.log(x);
      this.getRoutes();
      this.isLoading = false;
      this.toastr.success('Update Route', 'Route updated successfully');
      this.routr.navigateByUrl('/route/management/list');
    },
      error => {
        //console.log(error.error.Message)
        this.isLoading = false;
        this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
        // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        return;
      });


  }


  reloadCountries() {
    this.countryService.listAllCountries().subscribe(res => {
      this.countries = res;
      if (!this.isEdit) {
        let country = this.countries.find(x => {
          ////console.log('---Selected country : ', x);
          return x.code == 'ZA'
        });
        if (country) {          
          this.selectedDepartureCountry = country.desc;
          this.form.patchValue({
            departure_country_id: country.id
          });
          //console.log('---Selected country : ', this.selectedDepartureCountry);
          this.ctrlId = country.id;
          this.onSetDeparturePlaces(country.id);
          if (!this.isAllowed) {
            this.loadBordersByDepartureCountry(country.id);
          }
        }
      }
    });
  }

  onSetDeparturePlaces = (id) => {
  this.placeService.getAllCountryPlaces(id).subscribe(res => {
    this.departurePlaces = res;
    this.departurePlaces.push({ id: '', name: 'Choose a departure place*' });    
  },
    error => {
      this.departurePlaces = [];
      return;
    });
  }

  departureCountryChange(ref) {
    this.message = "Loading...";
    ////console.log('---Selected country ID: ', ref);
    ////console.log('---Loaded countries: ', this.countries);
    this.onSwitchOnOrOff(true);
    


    this.placeService.getAllCountryPlaces(ref).subscribe(res => {
      this.departurePlaces = res;
      this.selectedDepartureCountry = this.countries.find(x => {
        return x.id == ref
      }).desc;
      //this.patchFormWithDepRougLeg(this.form.value, this.departurePlaces[0].id);      
      this.onSwitchOnOrOff();
    },
      error => {
        this.departurePlaces = [];
        this.onSwitchOnOrOff();
        return;
      });
  }

  destinationCountryChange(ref) {
    this.message = "Loading...";
    this.onSwitchOnOrOff(true);
    this.destinationPlaces = [];
    //console.log(`${ref}.Des Cntry ID`);
    this.placeService.getAllCountryPlaces(ref).subscribe(res => {
      this.destinationPlaces = res;
      this.destinationPlaces.push({ id: '', name: 'Choose a destination place*' });
     ////console.log(`${ref}.Destination Country places = `, this.destinationPlaces);
      //this.selectedDestinationCountry = this.countries.find(x => {
      //  return x.id == ref
      //}).desc;
      this.form.patchValue({ destination_place_id: '' });
      if (this.isEdit) {       
        this.form.patchValue({ destination_place_id: this.routeLeg.destination_place_id });
      }
     
      this.onSwitchOnOrOff();
    },
      error => {
        this.destinationPlaces = [];
        this.onSwitchOnOrOff();
        return;
      });
  }
 
  //Border Grossings
  onGetBorderCrossings = (id, rType = 1,index) => {
    this.message = "Loading...";
    this.onSwitchOnOrOff(true);
    ////console.log('Route Type  ==>: ', rType);
    let count = this.borderPlaces.length;
    ////console.log('borderPlaces = > ', count + ' | ' + this.trackIndex);
    if (rType == 1) {
      this.placeService.getBorderCrossingsByCountryId(id).subscribe(border => {
        let borders: any = border;
        borders.push({ PlaceId: '', PlaceName: 'Choose a border crossing*' });
        //this.borderPlaces.push(borders);
        this.borderPlaces[index] = borders;
        ////console.log('Borders = > ', border);

        this.onSwitchOnOrOff();
      }, error => {
        //console.log('Error ==>: ', error);
        this.onSwitchOnOrOff();
      });
    } else {
      this.placeService.getStopsByCountryId(id).subscribe(border => {
        let borders: any = border;
        borders.push({ PlaceId: '', PlaceName: 'Choose a stop*' });
        //this.borderPlaces.push(borders);
        this.borderPlaces[index] = borders;
        ////console.log('Stops = > ', border);

        this.onSwitchOnOrOff();
      }, error => {
        //console.log('Error ==>: ', error);
        this.onSwitchOnOrOff();
      });
    }
    
  }


  createBorderCrossing(rType=1): UntypedFormGroup {
    return this.formBuilder.group({      
      legId:0,
      placeFrom: ['',Validators.required],
      placeTo:0,
      stepNum: 0,
      stopType: (rType == 2)?['', Validators.required]:0,
      routeType:rType
    });
  }

  addItem(rType = 1): void {
    this.borderCrossings = this.form.get('borderCrossings') as UntypedFormArray;
    this.borderCrossings.push(this.createBorderCrossing(rType));
    
    ////console.log('CTRLID = > ', this.ctrlId);
    ////console.log('# Border crossing = ', this.borderCrossings.length);
    const index = this.borderCrossings.length - 1;
    this.onGetBorderCrossings(this.ctrlId, rType,index);
    this.isAddModel = true;
    ////console.log('FormGroup = > ', this.form.controls.borderCrossings.controls[0].controls.crossingCountry);
  }

  addRouteLegs(borders: any): void {
    this.borderCrossings = this.form.get('borderCrossings') as UntypedFormArray;    
    let start = borders[0];
    let current: any;    
    borders.forEach(leg => {      
      if (leg.stepNum > 1) {
        this.borderCrossings.push(this.formBuilder.group({
          legId: leg.legId,
          placeFrom: leg.placeFrom,
          placeTo: leg.placeTo,
          stepNum: leg.stepNum,
          routeType: (start.placeTo == leg.placeFrom) ? start.routeType:leg.routeType,
          stopType: (start.placeTo == leg.placeFrom) ? start.stopType : leg.stopType,
        }));
        start = leg;
      } else {
        this.form.patchValue({ first_place_leg_id: leg.legId});
      }
      })      
    ////console.log('BorderCrossings = > ', this.borderCrossings);
    
  }

  onBorderCrossingChange = (item: any, index = 0) => {

    let id : Number = item;
    ////console.log('Places size : ', this.borderPlaces.length);
    ////console.log('Item = ' ,item);
       

    let country = this.borderPlaces[index].find(x => x.PlaceId == id);
    this.ctrlId = country.CountrySId;
    ////console.log('CTRL Id = ', this.ctrlId);

    this.selectedBorderCrossings[index] = country;
    ////console.log('Selected country : ', country);
    ////console.log('Selected countries : ', this.selectedBorderCrossings);
    this.selectedDestinationCountry = country.CountrySName
    this.destinationId = country.CountrySId;
    ////console.log('DestinationId = ', this.destinationId);
    //if (!this.isEdit)
    this.destinationCountryChange(this.destinationId);
    this.isAddModel = false;    
  }

  onRemoveItem = (index) => {    
    const rmv = this.selectedBorderCrossings[index];
    const border = this.borderPlaces[index];
    this.selectedBorderCrossings = this.selectedBorderCrossings.filter(x => x != rmv);
    this.borderPlaces = this.borderPlaces.filter((x, i) => i != index); 
    //console.log('Border Removed : ', border);
    //console.log('Border Crossing countries left : ', this.selectedBorderCrossings);
    this.borderCrossings.removeAt(index);
    //console.log('Border Crossing controls left : ', this.borderCrossings);
    let newIndex = index - 1;
    if (newIndex >= 0) {
      const country = this.selectedBorderCrossings[newIndex];
      //console.log('Previous Border Crossing control : ', this.borderCrossings.at(newIndex));
      //console.log('Previous Border Crossing Country : ', this.selectedBorderCrossings[newIndex]);
      const id = Number(country.PlaceId);
      //this.ctrlId = country.CountrySId;
      //this.onGetBorderCrossings(this.ctrlId);
      this.onAddOrRemove(id, newIndex);
    } else {
       this.selectedDestinationCountry = null;
       this.destinationPlaces = [];
       this.ctrlId = this.form.get('departure_country_id').value;
    }
    this.isAddModel = false;
  }


  onAddOrRemove = (id,index) => {

       // //console.log('Places : ', this.borderPlaces);
    ////console.log('Item = ' ,item);
    ////console.log('Item Id = ', id);
    ////console.log('Index : ', index);
    ////console.log('BorderPlaces : ', this.borderPlaces[index]);
    ////console.log('CTRL Id = ', this.ctrlId);
    let country = this.borderPlaces[index].find(x => x.PlaceId == id);
    this.ctrlId = country.CountrySId;

    this.selectedBorderCrossings[index] = country;
    //console.log('Selected country : ', country);
    ////console.log('Selected countries : ', this.selectedBorderCrossings);
    this.selectedDestinationCountry = country.CountrySName
    this.destinationId = country.CountrySId;
    this.destinationCountryChange(this.destinationId);
  }

  onSwitchOnOrOff = (state = false) => {
    this.isLoading = state;
  }

  onConstructRoute = (obj: any) => {
    const places = obj.borderCrossings;
    let crossings = [];
    if ((places) && (this.isAllowed)) {
      const length = places.length;
      if (length => 1) {
        let leg1 = { legId: Number(obj.first_place_leg_id), placeFrom: Number(obj.departure_place_id), placeTo: Number(places[0].placeFrom), stepNum: 1, routeType: Number(places[0].routeType), stopType: Number(places[0].stopType) };
        let leg2 = { legId: Number(places[length - 1].legId), placeFrom: Number(places[length - 1].placeFrom), placeTo: Number(obj.destination_place_id), stepNum: 99, routeType: Number(places[length - 1].routeType), stopType: Number(places[length - 1].stopType) };
        crossings.push(leg1);
        for (let i = 1; i < length; i++) {
          let legN = {
            legId: Number(places[i - 1].legId),
            placeFrom: Number(places[i - 1].placeFrom),
            placeTo: Number(places[i].placeFrom),
            stepNum: i + 1,
            routeType: Number(places[i].routeType),
            stopType: Number(places[i].stopType)
          };
          crossings.push(legN);
        }
        crossings.push(leg2);
      }     
    }        
    return {
      id: obj.id,
      route_type_ind: obj.route_type_ind,
      display_ind: obj.display_ind,
      code: obj.code,
      route_detail: obj.route_detail,
      route_summary: obj.route_summary,
      description: obj.description,
      is_active: obj.is_active,
      sort_order: obj.sort_order,
      group_code: obj.group_code,
      date_created: obj.date_created,
      departure_country_id: obj.departure_country_id,
      destination_country_id: obj.destination_country_id,
      route_led_id: obj.route_led_id,
      departure_place_id: obj.departure_place_id,
      destination_place_id: obj.destination_place_id,
      borderCrossings: (this.isAllowed)?crossings:[]
    }

  }

  onSubmit = (form: any) => {

    let rLeg: any = this.onConstructRoute(form);
    ////console.log("Routes = ", JSON.parse(JSON.stringify(rLeg))); return;
    this.message = (this.isEdit) ? "Updating route" : "Adding a new route";
    
    if (this.isEdit) {
      rLeg.date_modified = new Date().toLocaleString();
      rLeg.user_modified = this.user.LastName;
      this.onSwitchOnOrOff(true);
      this.routeService.editRouteLeg(rLeg).subscribe(
        result => {
          //console.log('Updated Route : ', result);
          this.onSwitchOnOrOff();
          this.toastr.success('Update Route', 'Route updated successfully');
          this.routr.navigateByUrl('/route/management/list');
        },
        error => {
          this.onSwitchOnOrOff();         
          this.toastr.error('Failed to update route. If the problem persists, please contact system administrator.', 'Save Route');
        }
      );

    } else {     
      rLeg.date_modified = rLeg.date_created = new Date().toLocaleString();
      rLeg.user_modified = rLeg.user_created = this.user.LastName;
      this.onSwitchOnOrOff(true);
      this.routeService.addRouteLeg(rLeg).subscribe(
        result => {
          //console.log('Added Route : ', result);
          this.onSwitchOnOrOff();
          this.toastr.success('Save Route', 'Route saved successfully');
          this.routr.navigateByUrl('/route/management/list');
        },
        error => {
          this.onSwitchOnOrOff();         
          this.toastr.error('Failed to save route. If the problem persists, please contact system administrator.', 'Save Route');
        }
      );
    }     
    ////console.log(JSON.parse(JSON.stringify(rLeg)));   
  }

  onLoadRouteById = (id) => {
    this.onSwitchOnOrOff(true);
    this.routeService.getRouteLegById(id).subscribe(
      resource => {       
        this.routeLeg = resource;
        ////console.log('*****routeLeg = ', this.routeLeg);
        this.form.patchValue({
          id: this.routeLeg.id,
          route_type_ind: this.routeLeg.route_type_ind,
          display_ind: this.routeLeg.display_ind,
          code: this.routeLeg.code,
          route_detail: this.routeLeg.route_detail,
          route_summary: this.routeLeg.route_summary,
          description: this.routeLeg.description,
          is_active: this.routeLeg.is_active,
          sort_order: this.routeLeg.sort_order,
          group_code: this.routeLeg.group_code,
          date_created: this.routeLeg.date_created,
          departure_place_id: this.routeLeg.departure_place_id,
          destination_place_id: this.routeLeg.destination_place_id,
          departure_country_id: this.routeLeg.departure_country_id,
          destination_country_id: this.routeLeg.destination_country_id,                  
        });
        if (this.isWithLegs(this.routeLeg.route_type_ind)) {
          this.ctrlId = this.routeLeg.departure_country_id;
          this.destinationId = this.routeLeg.destination_country_id;
          this.routeLeg.places.forEach(place => {
            this.borderPlaces.push(place);
          });
          ////console.log(' destination_place_id = ', this.form.get('destination_place_id').value);
          this.departureCountryChange(this.ctrlId);          
          this.onLoadForEdit();
          this.destinationCountryChange(this.routeLeg.destination_country_id);
          ////console.log('Destination country = ', this.routeLeg.destination_country_id);
          
        } else { //New logic
          this.ctrlId = this.routeLeg.departure_country_id;
          this.isAllowed = this.routeLeg.is_active;
          if (this.ctrlId > 0) {
            this.destinationId = this.routeLeg.destination_country_id;
            this.routeLeg.places.forEach(place => {
              this.borderPlaces.push(place);
            });
            ////console.log(' destination_place_id = ', this.form.get('destination_place_id').value);
            this.departureCountryChange(this.ctrlId);
            this.onLoadForEdit();
            this.destinationCountryChange(this.routeLeg.destination_country_id);
          } else {
            let country = this.countries.find(x => {
              ////console.log('---Selected country : ', x);
              return x.code == 'ZA'
            });
            if (country) {
              this.selectedDepartureCountry = country.desc;
              this.form.patchValue({
                departure_country_id: country.id
              });
              ////console.log('---Selected country : ', this.selectedDepartureCountry);
              this.ctrlId = country.id;
              this.onSetDeparturePlaces(country.id);
              if (!this.isAllowed) {
                this.loadBordersByDepartureCountry(country.id);
              }
            }
          
          }
        }
        this.onSwitchOnOrOff();
      },
      error => {
        this.onSwitchOnOrOff();
        //console.log('Problems : ', error);
        this.toastr.error('Failed to load route. If the problem persists, please contact system administrator.', 'Save Route');

      }
    );
  }

  onLoadForEdit = () => {
    let count = 0;
    this.addRouteLegs(this.routeLeg.borderCrossings);
    const legs = this.form.get('borderCrossings').controls;
    ////console.log('#Legs ==>: ', legs.length);
    
    legs.forEach(leg => {

      ////console.log('#Leg ==>: ', leg.value.legId + ' | ' + leg.value.placeFrom);
      let id = leg.value.placeFrom;
      //let id = leg.value.placeTo;
       this.onBorderCrossingChangeEdit(id, count);       
       count++;      
    });
    this.isWithLegs();
  }


  onBorderCrossingChangeEdit = (item: any, index = 0) => {

    let id: Number = item;
    //console.log('Places size : ', this.borderPlaces.length);
    //console.log('Item = ', item);    
    let country = this.borderPlaces[index].find(x => x.PlaceId == id);
    this.ctrlId = country.CountrySId;
    //console.log('CTRL Id = ', this.ctrlId);

    this.selectedBorderCrossings[index] = country;
    //console.log('Selected country : ', country);
    ////console.log('Selected countries : ', this.selectedBorderCrossings);
    this.selectedDestinationCountry = country.CountrySName
    this.destinationId = country.CountrySId;
    //console.log('DestinationId = ', this.destinationId);   
    this.isAddModel = false;
  }

  isWithLegs = (checker=0) => {
    
    this.isValidRoute();

    if (!this.isEdit) {
    if (!this.isAllowed) {
      this.form.patchValue({ is_active: false });      
      } else {
      this.form.patchValue({ is_active: true });      
      }
    }
    this.isRequired = (this.isAllowed) ? false : true;
    this.ctrlTabs();
    return this.isAllowed;
  }

  isActing(action = 0) {
    return (this.selectedBorderCrossings.length > action);
  }

  addValidation = () => {
    
    let route_detail = this.form.get('route_detail');
    let borderCrossings = this.form.get('borderCrossings');
    let departure_place_id = this.form.get('departure_place_id');
    let destination_place_id = this.form.get('destination_place_id');

    if (this.isAllowed) {     
      route_detail.clearValidators();
      borderCrossings.setValidators([Validators.required]);
      departure_place_id.setValidators([Validators.required]);
      destination_place_id.setValidators([Validators.required]);
    } else {     
      borderCrossings.clearValidators();
      departure_place_id.clearValidators();
      destination_place_id.clearValidators();
      route_detail.setValidators([Validators.required]);
    }

    borderCrossings.updateValueAndValidity();
    departure_place_id.updateValueAndValidity();
    destination_place_id.updateValueAndValidity();
    route_detail.updateValueAndValidity();   
  }
  

  onChanges(): void {    
    this.form.get('code').valueChanges.subscribe(code => {
      if (code.length > 1) {
        this.routeService.checkByCode(code.trim()).subscribe(result => {
          this.isCodeDup = (result.Status && !this.isEdit) ? true : false;
        }, error => {
          this.isCodeDup = false;
        });
      }
      else this.isCodeDup = false;      
    });
    
  }
  
  isBorder = (index: number) => {
    if (index == 0) return true;

    let currentLeg = this.borderCrossings.value[index];
    let prevLeg = this.borderCrossings.value[index - 1];           
    return (currentLeg.routeType != prevLeg.routeType);

  }

  isStop = (index: number) => {
    let currentLeg = this.borderCrossings.value[index];
    ////console.log("Current Leg = ", currentLeg);
    return (currentLeg.routeType == 2);
  }

  isMessage = (index) => {
    return (this.selectedBorderCrossings[index]) ? true : false;
  }


  loadBordersByDepartureCountry = (id) => {
    this.message = "Loading...";
    this.onSwitchOnOrOff(true);
    //console.log('Country ID : ', id);
    this.placeService.getBorderCrossingsByCountryId(id).subscribe(border => {
      let borders: any = border;
      borders.push({ PlaceId: '', PlaceName: 'Choose a border crossing*' });
      //this.borderPlaces.push(borders);
      this.list_borders = borders;
      ////console.log('Borders = > ', border);

      this.onSwitchOnOrOff();
    }, error => {
      //console.log('Error ==>: ', error);
      this.onSwitchOnOrOff();
    });
  }

  loadDestinationBasedOnBorderPost = (id) => {

    let border = this.list_borders.find(x => x.PlaceId == id);
    //console.log('Border : ', border);
    this.ls_destination = [{ id: border.CountrySId, desc: border.CountrySName }];
    //console.log('Destination : ', this.ls_destination);
    this.form.patchValue({ destination_country_id: border.CountrySId});
  }


  checkValidity = (activeRef) => {
    activeRef.preventDefault();
    this.isRequired = (this.isAllowed) ? false : true;
    const checked = activeRef.target.checked;        
    this.isAllowed = (checked) ? true : false;
    if (checked) {
      this.toastr.info('To make this route active, you need to add a departure, a destination and at least one border post.', 'Route Management');      
    } 
    this.ctrlTabs();   
  }

  ctrlTabs = () => {
    let links = $('.nav-tabs a');
    this.isValidRoute();
    if (this.isAllowed) {
      
      $('#desc').removeClass('active');
      $('#bord').addClass('active');
      $('#bord').addClass('show'); 
      links.eq(1).trigger('click');      
      //$('#bord').show(); // Show selected      
    } else {
      $('#bord').removeClass('active');
      $('#desc').addClass('active');
      $('#desc').addClass('show');
      links.eq(0).trigger('click');      
      //$('#desc').show();      
    }
    this.addValidation();    
  }

  isValidRoute = (checker = 0) => {
    const indicators = [3, 5, 13, 15];
    const current = Number(this.form.get('route_type_ind').value);
    this.isAllowed = (indicators.indexOf(current) > -1) ? true : false;    
  }

  backPage = () => {
    if (this.routeCtrl.isNew) {
      this.routeCtrl.isNew = false;
      this.routeCtrl.btnRadio = null;
    } else {
      this.routr.navigate(['/route/management/list']);
    }
  }

  addPermitRoute = (obj: any) => {

    let rLeg: any = this.onConstructRoute(obj);
    rLeg.date_modified = rLeg.date_created = new Date().toLocaleString();
    rLeg.user_modified = rLeg.user_created = this.user.LastName;

    //console.log('Route : ', rLeg);
    //console.log('IsAllowed : ', this.isAllowed);
    this.routeCtrl.rLeg = rLeg;
    this.routeCtrl.isNew = false;
    this.routeCtrl.btnRadio = 3;
  }

  generateCode = () => {
    let current_date = new Date();
    let code = 'C' +  (current_date.getMonth() + 1) +'' + current_date.getDate() + '' + current_date.getFullYear() + '' + current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds();
    const LETTERS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    const F = LETTERS[Math.floor(Math.random() * 26)];
    const L = LETTERS[Math.floor(Math.random() * 26)];
    const FINAL_CODE = F + code + L;
    //console.log('Code = ', FINAL_CODE);
    return FINAL_CODE;
   // //console.log('DATE = ', current_date.toLocaleTimeString());
    ////console.log('CHAR = ', LETTERS[index]);
  }

}
